// @ts-nocheck legacy file transformed to TS
import { Component } from 'react'
import PropTypes from 'prop-types'
import { errors } from 'utils/error-handling/errors'

class PromiseData extends Component {
  static propTypes = {
    promise: PropTypes.object.isRequired,
  }

  state = {
    data: undefined,
    meta: {},
  }

  mounted = false

  componentDidMount() {
    this.mounted = true
    this.load()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.promise === this.props.promise) return
    this.load()
  }

  componentWillUnmount() {
    this.mounted = false
    try {
      this.props.promise.cancel()
    } catch (e) {
      console.error(e)
    }
  }

  async load() {
    try {
      this.setState({
        data: undefined,
        meta: {},
      })

      const { data, meta } = await this.props.promise

      if (!this.mounted) {
        return
      }

      this.setState({
        data,
        meta: meta || {},
      })
    } catch (e) {
      if (!this.mounted) {
        return
      }

      this.setState({
        data: null,
        meta: {},
      })

      errors.captureException(e)
    }
  }

  render() {
    return this.props.children(
      this.props.promise.isPending(),
      this.props.promise.isRejected(),
      this.state.data,
      this.state.meta
    )
  }
}

export default PromiseData
